export const EMPTY_REWARD = { 
  name: "", 
  description: "", 
  points_required: "", 
  reward_type: "discount_percentage", 
  reward_value: "", 
  is_active: true 
};
